import { IFarmStatistics } from 'models/IFarm'
import { useMemo } from 'react'

export const useGetLamenessChartInfo = (props: IFarmStatistics | undefined) => {
	const dotsInfo = useMemo(() => {
		return props?.limpness?.map(el => ({
			segmentValue: el.value,
			color: el.color,
		}))
	}, [props?.limpness])

	const totalCattle = dotsInfo?.reduce(
		(acc, el) => acc + (el.segmentValue || 0),
		0,
	)

	const limpnessTotalCattles = useMemo(() => {
		if (!props?.limpness) return 0

		return props.limpness.slice(1).reduce((acc, el) => acc + (el.value || 0), 0)
	}, [props?.limpness])

	return { dotsInfo, totalCattle, limpnessTotalCattles }
}
